import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueCarousel from 'vue-carousel'
import * as VideoPlayer from 'vue-videojs7'
import Sticky from 'vue-sticky-directive'
import LoadScript from 'vue-plugin-load-script'
import VueTheMask from 'vue-the-mask'
import axios from 'axios'
import VueAxios from 'vue-axios'
import jwt from 'jsonwebtoken'
import ClipboardJS from 'clipboard'
import VueClipboard from 'vue-clipboard2'
import VueMoment from 'vue-moment'
import Maska from 'maska'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'

Vue.use(Sticky)
Vue.use(LoadScript)
Vue.use(VideoPlayer)
Vue.use(VueCarousel)
Vue.use(VueTheMask)
Vue.use(VueAxios, axios)
Vue.use(jwt)
Vue.use(VueClipboard)
Vue.use(VueMoment)
Vue.use(Maska)
Vue.config.productionTip = false

// const cdnServer = 'cdn.myvirtualbooth.info/'
const cdnServer = 'clients.didlabs.com/Loreal/sun-hero-program-2021/'
Vue.prototype.$jwt = require('jsonwebtoken')
Vue.prototype.$apiUrl = process.env.VUE_APP_API_URL

Vue.mixin({
  methods: {
    setOverlay (overlayId) {
      store.commit('SET_OVERLAY', overlayId)
    },
    grabCdn (path) {
      return `https://${cdnServer}${path}`
    }
  }
})

axios.interceptors.response.use((response) => response, (error) => {
  if (typeof error.response === 'undefined') {
    var errorMsg = '<strong>A network error occurred.</strong><br>' +
      'Something is preventing this page from communicating with the server.'
    return Promise.reject(errorMsg)
  } else if (error.response && error.response.status === 401) {
    var errorMsg = '<strong>Incorrect login credentials</strong><br>' +
      'Please check your username and password and try again.'
    return Promise.reject(errorMsg)
  } else if (error.response && error.response.status !== 409) {
    var errorMsg = '<strong>An unknown error occurred.</strong><br>' +
      'A server issue is preventing your request from completing.  Please try again later.'
    return Promise.reject(errorMsg)
  }
  return Promise.reject(error)
})

router.beforeEach((to, from, next) => {
  store.commit('SET_PREV_PAGE', from.path)
  store.state.navigationOpen = false
  next()
})

window.vue = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

/**
 * Formats a phone number.
 * Example: 123-456-7890 => (123) 456-7890
 *
 * @param {String} phone
 * @return {Void}
 */
Vue.filter('phone', function (phone) {
  if (phone) {
    return phone.replace(/[^0-9]/g, '')
      .replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3')
  }
  return ''
})
Vue.filter('cleanError', function (error) {
  if (error) {
    return error.toString().replace(/[\[\]"]/g, '')
  }
  return ''
})
